import axios, { AxiosRequestConfig } from 'axios';
import { TopConfig } from '../context/ConfigContext';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';

export type SavedForm = {
    formValues: FormValues;
    firstSavedDate: number;
};
export type AllSavedForms = Record<string, SavedForm>; // JSON of {formId: savedData}

export const getSavedFormDataByFormIdServiceConfig = (formConfig: FormConfig | undefined, topConfig: TopConfig) => {
    const { get: getSavedFormServiceConfig } = topConfig.services.storage;
    const { url, headers } = getSavedFormServiceConfig;

    if (!url) {
        throw new Error('Pet service: Url not defined');
    }

    if (!formConfig) {
        throw new Error('Form config is undefined');
    }

    return {
        ...getSavedFormServiceConfig,
        url: url + formConfig.formId,
        headers: {
            ...headers,
            'x-top-stakeholder-viewids': 'ACTIVEUSER'
        }
    };
};

export const saveFormDataGetAll = async (topConfig: TopConfig): Promise<AllSavedForms | false> => {
    const isLoggedOn = window.topContext.user.isLoggedOn;

    if (!isLoggedOn) {
        return false;
    }

    const { get } = topConfig.services.storage;
    const requestConfig: AxiosRequestConfig = {
        ...get,
        url: get.url + 'all',
        headers: {
            ...get.headers,
            'x-top-stakeholder-viewids': 'ACTIVEUSER'
        }
    };

    try {
        const response = await axios(requestConfig);
        return response.data;
    } catch (error: any) {
        console.error('Could not get all forms');
        console.error(' - Error: ', error);
        console.error(' - Payload: ' + JSON.stringify(requestConfig, null, 4));

        return false;
    }
};

export const saveFormDataSave = async (
    formConfig: FormConfig,
    formValues: { [key: string]: any },
    topConfig: TopConfig
) => {
    const formId = formConfig.formId;

    const isLoggedOn = window.topContext.user.isLoggedOn;

    if (!isLoggedOn) {
        return false;
    }

    const { save } = topConfig.services.storage;
    const requestConfig: AxiosRequestConfig = {
        ...save,
        url: save.url + formId,
        data: {
            formValues,
            formName: formConfig.caption
        },
        headers: {
            ...save.headers,
            'x-top-stakeholder-viewids': 'ACTIVEUSER'
        }
    };

    try {
        await axios(requestConfig);

        return true;
    } catch (error) {
        console.error('Could not save form:' + formId);
        console.error(' - Error: ', error);
        console.error(' - Payload: ' + JSON.stringify(requestConfig, null, 4));

        return false;
    }
};

export const saveFormDataDelete = async (formConfig: FormConfig, topConfig: TopConfig) => {
    const formId = formConfig.formId;

    const isLoggedOn = window.topContext.user.isLoggedOn;

    if (!isLoggedOn || !formConfig.enableSave) {
        return false;
    }

    const { delete: deleteForm } = topConfig.services.storage;
    const requestConfig: AxiosRequestConfig = {
        ...deleteForm,
        url: deleteForm.url + formId,
        headers: {
            ...deleteForm.headers,
            'x-top-stakeholder-viewids': 'ACTIVEUSER'
        }
    };

    try {
        await axios(requestConfig);

        return true;
    } catch (error) {
        console.error('Could not delete form:' + formId);
        console.error(' - Error: ', error);
        console.error(' - Payload: ' + JSON.stringify(requestConfig, null, 4));

        throw new Error(`Could not delete form data - ${JSON.stringify(error)}`);
    }
};
